module.exports = __webpack_public_path__ + "src/assets/games/26/175.jpg";